<script setup lang="ts">
import { computed } from 'vue'
import DrillActionTile from './DrillActionTile.vue'
import type { DrillAtomAction, DrillAtomSuggestedAction } from '@acepoker/contract'

type SortedAction = DrillAtomSuggestedAction & { originIndex: number }

const ACTIONS_ORDER = ['f', 'c', 'x', 'r', 'allin']

const actionToShortcut = {
  allin: 'allin',
  bet: 'r',
  call: 'c',
  check: 'x',
  fold: 'f',
  raise: 'r'
}

const props = defineProps<{
  data: DrillAtomAction
  active?: boolean
}>()

const sortedActions = computed<SortedAction[]>(() =>
  (props.data.actions as SortedAction[])
    .map((el, i) => ({ ...el, originIndex: i }))
    .sort(({ action: a }, { action: b }) => {
      const aShortcut = actionToShortcut[a]
      const bShortcut = actionToShortcut[b]
      const aIndex = ACTIONS_ORDER.indexOf(aShortcut)
      const bIndex = ACTIONS_ORDER.indexOf(bShortcut)
      return aIndex - bIndex
    })
)

const emit = defineEmits<{
  change: [action: DrillAtomAction]
}>()

function onSelectAction(selected: number) {
  emit('change', {
    ...props.data,
    selected
  })
}
</script>

<template>
  <DrillActionTile :active="props.active">
    <template #header>
      <div class="flex justify-between">
        <span>{{ data.position }}</span>
        <span class="text-secondary">{{ data.pot }}</span>
      </div>
    </template>

    <ul>
      <li
        v-for="(action, i) in sortedActions"
        :key="action.originIndex"
        class="hover:bg-stroke-inactive/80 data-[selected=true]:bg-stroke-inactive group-data-[active=true]:data-[selected=true]:bg-primary-button mt-[2px] cursor-pointer rounded-sm px-1 py-px text-[13px] whitespace-nowrap capitalize"
        :data-selected="action.originIndex === data.selected"
        @click="onSelectAction(action.originIndex)"
      >
        {{ action.action }}
        <template v-if="action.amount && action.action !== 'allin'">{{ action.amount }}</template>
        <!-- <span class="text-secondary text-xs ml-1">{{ (action.strategy * 100).toFixed(1) }} %</span> -->
      </li>
    </ul>
  </DrillActionTile>
</template>

<style scoped></style>
